export default "__VITE_ASSET__j2vtR57p__"